import { Loader2 } from "lucide-react";
import { useLanguage } from "@/lib/i18n/LanguageContext";

export function AccessReadiness({
  failed,
  retry,
  message,
  loadingLabel,
  fullHeight = false,
}: {
  failed: boolean;
  retry: () => void;
  message: string;
  loadingLabel: string;
  fullHeight?: boolean;
}) {
  const { t } = useLanguage();
  return (
    <div
      className={`flex items-center justify-center ${fullHeight ? "min-h-screen" : "py-16"}`}
      role={failed ? "alert" : "status"}
      aria-label={failed ? undefined : loadingLabel}
    >
      {failed ? (
        <div className="flex flex-col items-center gap-3 text-center">
          <p>{message}</p>
          <button type="button" className="text-primary underline" onClick={retry}>
            {t.common.retry}
          </button>
        </div>
      ) : (
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      )}
    </div>
  );
}
